/**
 * Выбранный вид против РАЗРЕШЁННОГО района — не против кадра карты.
 *
 * Два похожих вопроса, и путать их нельзя. `regionFilter.splitSpecies` делит
 * каталог по ВЬЮПОРТУ: вид чужого бассейна там не исчезает, а уезжает в группу
 * «вне района», потому что карта могла просто улететь за границу, и стирать
 * рабочий контекст от движения мыши нельзя. Здесь вопрос другой и ответ
 * жёстче: домен и права организации решили, каких бассейнов у этого кабинета
 * НЕТ ВООБЩЕ, и вид оттуда выбранным быть не может — сколько карту ни двигай.
 *
 * Бой 08.09.2026, aquaculture.lv: ссылка `?species=26` (сайра) и умолчание
 * раздела (`MODELS_DEFAULT_SPECIES = 26`) давали балтийскому кабинету
 * тихоокеанский вид. Селектор честно рисовал его строкой «Outside the area», а
 * карта считала HSI по виду, которого в этом море не бывает.
 *
 * СНЯТЫЙ ВЫБОР — НОРМАЛЬНОЕ СОСТОЯНИЕ (решение владельца 08.09.2026): ни один
 * вид не выбран, кнопка расчёта ждёт выбора. Подставлять «первый подходящий»
 * было бы догадкой за человека, а догадка тут неотличима от его собственного
 * выбора.
 *
 * НАБОР РАЙОНОВ ПРИЕЗЖАЕТ ЭФФЕКТИВНЫМ (`brand.regions ∩ org.allowed_regions`,
 * ответ `/species`) — считает его сервер. Пересчитывать пересечение в браузере
 * значило бы завести второй источник правды о правах.
 */

import type { RegionItem, SpeciesItem } from '../api'

/**
 * Вид, который вправе остаться выбранным. `null` — снять выбор.
 *
 * Четыре случая молчания, и каждый написан против пустого селектора на ровном
 * месте: каталог не приехал, районы не приехали, вида нет в каталоге (судить не
 * по чему — пункт-сироту рисует `orphanSpecies`) и вид без привязки («пусто =
 * везде», то же правило, что у `species_region` и у видов в боте).
 */
export function clampSpeciesToScope(
  selected: number | null,
  species: SpeciesItem[],
  regions: RegionItem[],
): number | null {
  if (selected == null) return null
  if (species.length === 0 || regions.length === 0) return selected
  const item = species.find(s => s.species_id === selected)
  if (!item) return selected
  const codes = item.regions ?? []
  if (codes.length === 0) return selected
  const allowed = new Set(regions.map(r => r.code))
  return codes.some(c => allowed.has(c)) ? selected : null
}
